import React from 'react';
import BasePageContainer from 'src/components/CommonV2Components/BasePageContainer/BasePageContainer';
import LifetimeRatingVolumeByStarRatingChart from 'src/components/BeaconV2Components/ExperimentalLayout/Reviews/ReviewRatings/LifetimeRatingVolumeByStarRatingChart';
import ProductCatalogCountRatingChart from 'src/components/BeaconV2Components/ExperimentalLayout/Reviews/ReviewRatings/ProductCatalogCountRatingChart';
import ProductCatalogCountRatingVolumeChart from 'src/components/BeaconV2Components/ExperimentalLayout/Reviews/ReviewRatings/ProductCatalogCountRatingVolumeChart';
import ReviewChildWeeklyRatingVolumeProductChart from 'src/components/BeaconV2Components/ExperimentalLayout/Reviews/ReviewRatings/ReveiwWeeklyRatingVolumeProductChart';
import ReviewRatingDoubleDropdownByCategoryChart from 'src/components/BeaconV2Components/ExperimentalLayout/Reviews/ReviewRatings/ReviewRatingDoubleDropdownByCategoryChart';
import { WeeklyRatingTable } from 'src/components/BeaconV2Components/ExperimentalLayout/Reviews/ReviewRatings/WeeklyRatingTable';
import WeeklyRatingVolumeByStarRatingChart from 'src/components/BeaconV2Components/ExperimentalLayout/Reviews/ReviewRatings/WeeklyRatingVolumeByStarRatingChart';
import ReviewSummaryProductGrid from 'src/components/BeaconV2Components/ExperimentalLayout/Reviews/ReviewSummary/ReviewSummaryProductGrid';
import { useReviewCumulativeValues } from 'src/components/BeaconV2Components/ExperimentalLayout/Reviews/ReviewsHooks';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import { EntityNoDataPlaceHolder } from 'src/components/BeaconV2Components/common/NoDataPlaceHolder/NoDataPlaceHolder';
import { BEACON_CHART_SPACING } from 'src/components/Layout/Beacon/BeaconProLayoutConsts';
import { useCategoryEntity, useProductEntity, useSubcategoryEntity } from 'src/utils/Hooks/reduxSelectors';
import { useFieldLevel } from 'src/components/BeaconV2Components/ExperimentalLayout/Reviews/ReviewsHooks';
import ReviewWeeklyRatingVolumeChart from 'src/components/BeaconV2Components/ExperimentalLayout/Reviews/ReviewRatings/ReviewWeeklyRatingVolumeChart';

const ReviewRatingsPage = () => {
  const { isProductEntity } = useProductEntity();
  const { isCategoryEntity } = useCategoryEntity();
  const { isSubcategoryEntity } = useSubcategoryEntity();
  const fieldLevel = useFieldLevel();

  const { reviewCumulativeCountData, reviewCumulativeCountLoading } = useReviewCumulativeValues({
    aggregationFieldNames: [`${fieldLevel}LifetimeRatingVolume`]
  });

  return (
    <BasePageContainer>
      <Flex flexDirection="column" gap={BEACON_CHART_SPACING}>
        {!reviewCumulativeCountLoading && reviewCumulativeCountData?.length === 0 ? (
          EntityNoDataPlaceHolder
        ) : (
          <>
            {/* Weekly rating volume */}
            {/* <ReviewWeeklyRatingVolumeChart />
            {isProductEntity && <ReviewChildWeeklyRatingVolumeProductChart />}
 */}
            {/* Weekly Rating Volume by Star Rating */}
            {/* <WeeklyRatingVolumeByStarRatingChart /> */}
            {/* Cumulative Rating Volume by Star Rating */}
            <LifetimeRatingVolumeByStarRatingChart />
            {/* Product Catalog Count by Cumulative Rating Volume Tier */}
            {!isProductEntity && <ProductCatalogCountRatingVolumeChart />}
            {/* Product Catalog Count by Cumulative */}
            {!isProductEntity && <ProductCatalogCountRatingChart />}
            {/* Cumulative Rating Volume By Category */}
            {!isCategoryEntity && !isSubcategoryEntity && !isProductEntity && (
              <ReviewRatingDoubleDropdownByCategoryChart groupByField="categoryId" />
            )}
            {/* Cumulative rating volume by subcategory  */}
            {!isSubcategoryEntity && !isProductEntity && (
              <ReviewRatingDoubleDropdownByCategoryChart groupByField="subCategoryId" />
            )}
            {/* Cumulative rating volume by product */}
            {!isProductEntity && <ReviewSummaryProductGrid tableComponent="review" />}
            {isProductEntity && <WeeklyRatingTable />}
          </>
        )}
      </Flex>
    </BasePageContainer>
  );
};

export default ReviewRatingsPage;
